import { render, staticRenderFns } from "./link-table-column-object-item.vue?vue&type=template&id=a393c8b0&"
import script from "./link-table-column-object-item.vue?vue&type=script&lang=js&"
export * from "./link-table-column-object-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports